import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { RatelistType } from "@sinch/core/entities/serverEnums";
import { MdsCopyAll } from "@sinch/icons";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useRatelist } from "@sinch/components/application/Rate/useRatelist";
import { useRatelistType } from "@sinch/components/application/Rate/useRatelistType";

export const CopyMenuItem = ({ id, type }: { id: string; type: RatelistType }) => {
  const { t } = useTranslation(["common", "draft"]);
  const { copy: copyRatelist } = useRatelist();
  const { getRatelistTypeEditUri } = useRatelistType();

  const handleCopy = useCallback(async () => {
    const result = await copyRatelist({ variables: { id: id } });
    const newId = result.data?.copyRatelist.payload?.id;
    if (result.data?.copyRatelist.result && newId) {
      globalThis.location.href = getRatelistTypeEditUri(type)(newId);
    }
  }, [copyRatelist, getRatelistTypeEditUri, id, type]);

  return (
    <MenuItem onClick={handleCopy}>
      <ListItemIcon>
        <MdsIcon icon={MdsCopyAll} />
      </ListItemIcon>
      <ListItemText>{t("Action.copy")}</ListItemText>
    </MenuItem>
  );
};
